import React, { Component } from 'react';
import history from '../history';
import Spinner from '../components/Spinner';
import Menu from '../components/Menu';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Form from '../components/EditForm';
import { $ } from 'jquery';
import { formData,GetData,generateDropdownData } from '../common';
import queryString from 'query-string';

export default class Grid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            label: "Invoice",
            sublabel: "Invoice",
            breadcrumbs: [{ label: "Invoice", href: "/invoices" }],
            endpoint: "invoices/",
            pageLinks: [{ label: "Manage Invoice", link: "/invoices" }],
            columns: [
                { label: "Quantity", name: "quantity", required: true, type: "text" },
                { label: "Price", name: "price", required: true, type: "text"},
                { label: "Measurement", name: "measurement", required: true, type: "text" },
                { label: "Delivery", name: "delivery", required: true, type: "text" },
                { label: "User", name: "user_id", required: true, type: "select" },
                { label: "Product", name: "product_id", required: true, type: "select" },
                { label: "Fabric", name: "fabric_id", required: true, type: "select" },
                { label: "Fabric Color", name: "fabric_color", required: true, type: "select" },
                { label: "Flows", name: "flows", required: true, type: "select" },
            ],
            payload: {

            },
            id: ""
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        var products=await GetData("products/");
        var fabric=await GetData("fabrics/");
        var fabrics_color=await GetData("fabriccolorassignment/");
        var flows=await GetData("flows/");
        var users=await GetData("users/");

        var prod_list=generateDropdownData(products,"id|name");
        var fabric_list=generateDropdownData(fabric,"id|name");
        var fab_color_list=generateDropdownData(fabrics_color,"id|color_name");
        var flow_list=generateDropdownData(flows,"id|name");
        var user_list=generateDropdownData(users,"id|username");


        var columns=this.state.columns;
        columns[4]['data']=user_list;
        columns[5]['data']=prod_list;
        columns[6]['data']=fabric_list;
        columns[7]['data']=fab_color_list;
        columns[8]['data']=flow_list;

        this.setState({columns:columns});

    }

    onChange = async (event) => {
        var payload = this.state.payload;
        payload[event.target.name] = event.target.value;
        this.setState({ payload: payload });


        this.setState({ payload: payload });
    }



    render() {
        const { breadcrumbs, label, sublabel, columns, pageLinks } = this.state;

        return (
            <>
                <Header />
                <Menu />
                <div class="content-wrap">
                    <main id="content" class="content" role="main">

                        <ol className="breadcrumb">
                            {breadcrumbs.map(data => {
                                return <li className="breadcrumb-item"><a href={(data.href != "") ? data.href : "#"}><strong>{data.label}</strong></a></li>
                            })}
                        </ol>
                        <h2 className="page-title"><span className="fw-semi-bold">{label}</span></h2>
                        <section class="widget">
                            <header>
                                <h5>
                                    <span className="fw-semi-bold">{sublabel}</span>
                                </h5>
                                <div class="widget-controls">
                                    {pageLinks.map(data => {
                                        return <a href={data.link} class="btn btn-primary mt-2 mr-3 text-white py-1 px-2" role="button">{data.label}</a>
                                    })}
                                </div>
                            </header>
                            <div class="widget-body">

                                <div class="row">
                                    <Form data={this.state} id={queryString.parse(this.props.location.search).id} />
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </main>
                </div>
                <div class="loader-wrap hiding hide">
                    <i class="fa fa-circle-o-notch fa-spin-fast"></i>
                </div>
            </>
        );
    }
}